enum Steps {
    Charity = 0,
    Payment = 1,
}

export default Steps;
